import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <p>© Copyright Websole.pk || All Rights Reserved</p>
        <p>Designed by <span className='kaleem'>Kaleem Ullah Moon</span></p>
    </div>
  )
}

export default Footer;